import { useEffect, useRef } from 'react';

import useLocalStorage from '../useLocalStorage';

const CACHE_KEY = 'equip.messages.removed';

interface RemovedMessageCacheState {
  addToCache: (messageId: number) => void;
  isInCache: (messageId: number) => boolean;
}

const useRemovedMessageCache = (): RemovedMessageCacheState => {
  const cache = useRef<number[]>(null);
  const { getValueFromLocalStorage, setValue } = useLocalStorage(CACHE_KEY, []);

  useEffect(() => {
    if (!cache.current) {
      cache.current = getValueFromLocalStorage();
    }
  }, []);

  const isInCache = (messageId: number): boolean => {
    return cache.current?.includes(messageId);
  };

  const addToCache = (messageId: number) => {
    if (!isInCache(messageId)) {
      cache.current?.push(messageId);
      setValue(cache.current);
    }
  };

  return { addToCache, isInCache };
};

export default useRemovedMessageCache;
